import { render, staticRenderFns } from "./bilgidialog.vue?vue&type=template&id=24467e61"
import script from "./bilgidialog.vue?vue&type=script&lang=js"
export * from "./bilgidialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports